import { Button } from '@art-of-hospitality-solutions-llc/ui-kit/components/button';
import {
  Card,
  CardDescription,
  CardFooter,
  CardHeader,
} from '@art-of-hospitality-solutions-llc/ui-kit/components/card';
import { Heading } from '@art-of-hospitality-solutions-llc/ui-kit/components/heading';
import Breadcrumbs from '@Components/Breadcrumbs';
import { Link } from 'react-router-dom';

export default function Events() {
  return (
    <div className="w-full">
      <Breadcrumbs navList={[{ name: 'Events', href: '/events' }]} />
      <div className="mt-8 mb-4 flex items-center justify-between">
        <div>
          <Heading>Events</Heading>
          <p>Manage the events within your organization.</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Event Manager</Heading>
            <CardDescription>
              View and manage all your events in a calendar format.
            </CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/events/calendar">View Calendar</Link>
            </Button>
          </CardFooter>
        </Card>
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Events</Heading>
            <CardDescription>
              All general events within your organization.
            </CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/events/general">Manage Events</Link>
            </Button>
          </CardFooter>
        </Card>
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Ticketed Events</Heading>
            <CardDescription>
              Manage your ticketed events and their details.
            </CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/ticketed-events">Manage Ticketed Events</Link>
            </Button>
          </CardFooter>
        </Card>
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Categories</Heading>
            <CardDescription>Manage event categories.</CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/events/categories">Manage Categories</Link>
            </Button>
          </CardFooter>
        </Card>
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Tags</Heading>
            <CardDescription>Manage event tags.</CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/events/tags">Manage Tags</Link>
            </Button>
          </CardFooter>
        </Card>
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Organizers</Heading>
            <CardDescription>Manage event organizers.</CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/events/organizers">Manage Organizers</Link>
            </Button>
          </CardFooter>
        </Card>
        <Card className="h-full">
          <CardHeader>
            <Heading level="h2">Private Dining Events</Heading>
            <CardDescription>
              Manage private dining events and bookings.
            </CardDescription>
          </CardHeader>
          <CardFooter>
            <Button asChild>
              <Link to="/private-dining-events">Manage Private Dining</Link>
            </Button>
          </CardFooter>
        </Card>
      </div>
    </div>
  );
}
